export const MarketLinks = {
  TERMS_OF_USE: 'https://legal.splash-market.com/terms',
  PRIVACY_POLICY: 'https://legal.splash-market.com/privacy',
  FULL_RULES: 'https://legal.splash-market.com/market-rules',
  CUSTOMER_RISK_DISCLOSURES: 'https://legal.splash-market.com/disclosures',
  COMMODITY_FUTURES_TRADING_COMMISSION: 'https://www.cftc.gov/IndustryOversight/index.htm',
} as const;

export const PolymarketLinks = {
  PARTICIPANT_AGREEMENT: 'https://polymarketexchange.com/regulatory.html',
  CLEARING_RULEBOOK: 'https://polymarketexchange.com/clearing/',
  EXCHANGE_RULEBOOK: 'https://polymarketexchange.com/regulatory.html',
  RISK_DISCLOSURE: 'https://polymarketexchange.com/clearing/',
} as const;
